import { render, staticRenderFns } from "./lgportada.vue?vue&type=template&id=4a21c930&"
import script from "./lgportada.vue?vue&type=script&lang=js&"
export * from "./lgportada.vue?vue&type=script&lang=js&"
import style0 from "./lgportada.vue?vue&type=style&index=0&id=4a21c930&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports